import { MDBListGroup, MDBListGroupItem } from "mdb-react-ui-kit";

export const renderListItems = (items, renderItem) => {
  return items?.map((item, index) => (
    <MDBListGroup flush key={index}>
      {renderItem(item)}
    </MDBListGroup>
  ));
};

export const renderClearSkiesItem = (item) => (
    <MDBListGroupItem>
        <div>
            {item.processing ?
                (<span className='text-secondary'>Service is currently processing your request. Please wait.</span>)
                :
                (<><strong>Alarm: </strong>{item.status}</>)
            }
        </div>
    </MDBListGroupItem>
);
